import store from 'web-app/react/redux/store';
import * as GlobalEventActions from 'web-app/react/global-event/actions';

export const updateError = message => {
    store.dispatch(GlobalEventActions.updateError.action(message));
};

export const updateSuccess = message => {
    store.dispatch(GlobalEventActions.updateSuccess.action(message));
};
